var STEP_INDICATOR_VARIANT;
(function (STEP_INDICATOR_VARIANT) {
    STEP_INDICATOR_VARIANT["dot"] = "dot";
    STEP_INDICATOR_VARIANT["number"] = "number";
})(STEP_INDICATOR_VARIANT || (STEP_INDICATOR_VARIANT = {}));
var STEP_INDICATOR_COLOR;
(function (STEP_INDICATOR_COLOR) {
    STEP_INDICATOR_COLOR["light"] = "light";
    STEP_INDICATOR_COLOR["dark"] = "dark";
})(STEP_INDICATOR_COLOR || (STEP_INDICATOR_COLOR = {}));
var STEP_INDICATOR_SIZE;
(function (STEP_INDICATOR_SIZE) {
    STEP_INDICATOR_SIZE["medium"] = "medium";
    STEP_INDICATOR_SIZE["small"] = "small";
})(STEP_INDICATOR_SIZE || (STEP_INDICATOR_SIZE = {}));

export { STEP_INDICATOR_COLOR as S, STEP_INDICATOR_SIZE as a, STEP_INDICATOR_VARIANT as b };
